import React from 'react';
import styled, { css } from 'styled-components';
import { Box, InfoBanner } from '@sparknz/spark-pattern-library';

import { useTrackIneligibleWarningEvent } from 'journey/productDetails/components/ProductConfigurator/components/WearableEligibilityActionLayerContent/component/hooks';
import { BillingAccount } from 'shared/components';

interface IneligibleAccountWarningProps {
  index?: number;
  accountList?: BillingAccount[];
}

const List = styled.ol`
  ${({ theme: { spacing } }) => css`
    padding: ${spacing.s2} 0 0 ${spacing.s2};
    margin: 0;
    list-style: decimal;
  `}
`;

const ListItem = styled.li`
  ${({ theme: { spacing } }) => css`
    padding: 0;
    margin-bottom: ${spacing.s0_5};
  `}
`;

const InfoBannerContainer = styled(Box)<IneligibleAccountWarningProps>`
  ${({ index, accountList, theme: { spacing } }) => css`
    margin-bottom: ${index !== accountList?.length - 1 ? spacing.s2 : ''};
  `}
`;

const TRACKING_DATA = {
  componentID: 'productDetails.checkEligibility.wearableAccountDetails',
  componentName: 'Wearable Account Details',
  subCategory: 'Wearable Account',
  message: `This account isn't eligible to buy this watch with Interest Free Payments. To buy this watch you'll need to either: 1. Pay without a payment plan, just close this window and select Pay upfront from the payment options; or 2. Select a different account that is eligible.`,
};

export default function IneligibleAccountWarning({
  index,
  accountList,
}: IneligibleAccountWarningProps) {
  useTrackIneligibleWarningEvent(TRACKING_DATA);
  return (
    <InfoBannerContainer index={index} accountList={accountList} pt="s1">
      <InfoBanner variant="WARN">
        This account isn&apos;t eligible to buy this watch with Interest Free
        Payments. To buy this watch you&apos;ll need to either:
        <List>
          <ListItem>
            Pay without a payment plan, just close this window and select Pay
            upfront from the payment options; or
          </ListItem>
          <ListItem>Select a different account that is eligible.</ListItem>
        </List>
      </InfoBanner>
    </InfoBannerContainer>
  );
}
